import React, { useState } from "react";
import { imgUrl } from "@/lib/api";

/**
 * Delicate macro bubble hotspot.
 * Position is relative (0-1) on the parent container. On click, the caption
 * pane fades in with a hairline leader line linking to the dot.
 */
const HotspotBubble = ({ hotspot, index }) => {
  const [open, setOpen] = useState(false);
  const { x, y, label, caption, image } = hotspot;
  // Clamp so the pulsing ring never touches the plinth edge.
  const cx = Math.min(0.94, Math.max(0.06, x));
  const cy = Math.min(0.94, Math.max(0.06, y));
  const flipLeft = cx > 0.55;
  const flipUp = cy > 0.55;

  return (
    <div
      className="absolute"
      style={{ left: `${cx * 100}%`, top: `${cy * 100}%`, transform: "translate(-50%, -50%)" }}
      data-testid={`hotspot-${hotspot.key}`}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={label}
        className="relative flex items-center justify-center w-6 h-6 rounded-full hairline hotspot-dot"
        style={{ background: "var(--ground)" }}
      >
        <span className="w-2 h-2 rounded-full" style={{ background: "var(--accent)" }} />
      </button>

      {open && (
        <div
          className="absolute z-10 pointer-events-none"
          style={{
            [flipLeft ? "right" : "left"]: 30,
            [flipUp ? "bottom" : "top"]: 30,
          }}
        >
          {/* leader */}
          <div
            className="absolute"
            style={{
              [flipLeft ? "right" : "left"]: -30,
              [flipUp ? "bottom" : "top"]: 12,
              width: 30, height: 1, background: "var(--stone)",
            }}
          />
          <div className="pointer-events-auto w-[240px] hairline p-3 flex gap-3 items-start" style={{ background: "var(--ground)" }}>
            {image && (
              <img src={imgUrl(image)} alt={label} className="w-[64px] h-[64px] object-cover flex-none" />
            )}
            <div>
              <div className="serif text-lg leading-tight">{label}</div>
              <div className="text-xs text-ink/70 mt-1 leading-relaxed">{caption}</div>
              <button
                onClick={() => setOpen(false)}
                className="text-[10px] tracking-[0.2em] uppercase mt-3 text-ink/50 hover:text-accent"
                data-testid={`hotspot-close-${hotspot.key}`}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HotspotBubble;
